import React from 'react';
import { Modal, Form, Input, Button, notification, Row, Col, message} from 'antd';
import { RegisterRequest,  } from '../constant';
import { RegisterUser } from '../api/Register';

interface RegisterModalProps {
    visible: boolean;
    onCancel: () => void;
  }
  
const RegisterModal: React.FC<RegisterModalProps> = ({ visible, onCancel }) => {
  const [form] = Form.useForm();

  const onFinish = (registerrequest: RegisterRequest) => {

    RegisterUser(registerrequest)
        .then((registerresponse) => {
          if (registerresponse.success)
          {
            notification.success({
                message: 'Registration Complete',
                description: 'Your registration was successful. Please wait for verification.',
              });
          }
          else{
            if (registerresponse.msg === "not found")
            {
              Modal.info({
              title: "Error",
              content: (
                <div>
                  We don't have that license number in our system. <br />
                  Please email a PDF copy to{" "}
                  <span style={{ color: "blue" }}>ed@sla-az.org</span> and we will setup your account.
                </div>
              ),
            });
            }
            else{
              message.error(registerresponse.msg)
            }
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error.message);
          return
        });   
    
    form.resetFields();  
    onCancel();  
  };

  return (
    <Modal
      open={visible}
      title="Register to use the online filing system"
      className='register-text-style'
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <div className='text-xs'>
        Once you have completed the registration our office will verify it.  This is usually done within a few hours.  
        If you have any questions, please call our office at <span className='text-blue-500'>602-279-6344</span>.
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          firstName: '',
          lastName: '',
          licenseeName: '',
          phoneNumber: '',
          emailAddress: '',
          licenseNumber: '',
          licenseNumber2: '',
          username: '',
          password: '',
          password2: ''
        }}
        style={{ marginTop: 20 }}
      >
        {/* First Name and Last Name */}
        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>First Name : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="firstName"
              rules={[{ required: true, message: 'Please input your first name!' }]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Last Name : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="lastName"
              rules={[{ required: true, message: 'Please input your last name!' }]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        {/* Licensee Name and Phone Number */}
        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Licensee Name : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="licenseeName"
              rules={[{ required: true, message: 'Please input your licensee name!' }]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Phone Number : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="phoneNumber"
              rules={[{ required: true, message: 'Please input your phone number!' }]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        {/* Email Address and License Number */}
        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Email Address : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="emailAddress"
              rules={[
                { required: true, message: 'Please input your email address!' },
                { type: 'email', message: 'Please input a valid email address!' },
              ]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>License Number : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="licenseNumber"
              rules={[{ required: true, message: 'Please input your license number!' }]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        {/* Re-enter License Number and Requested Username */}
        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Re-enter License Number : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="licenseNumber2"
              rules={[
                { required: true, message: 'Please reenter your license number!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('licenseNumber') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('The license numbers do not match!'));
                  },
                }),
              ]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Requested Username : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Please input your requested username!' }]}
            >
              <Input className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        {/* Password and Re-enter Password */}
        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Password : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8} style={{ textAlign: 'right' }} className='mt-1'>
            <label>Re-enter Password : </label>
          </Col>
          <Col span={16}>
            <Form.Item
              name="password2"
              dependencies={['password']}
              rules={[
                { required: true, message: 'Please reenter your password!' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('The passwords do not match!'));
                  },
                }),
              ]}
            >
              <Input.Password className='register-input-style'/>
            </Form.Item>
          </Col>
        </Row>

        <div  className='grid justify-items-center'>
            <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '200px'}}>
                Register
            </Button>
            </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};


export default RegisterModal;